/* eslint-disable no-unused-vars */
import { Link } from "react-router-dom";
import "./Join.css";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Seo from "../../components/Seo/Seo";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const OTHER_JOB_VALUE = "__other__";

function JoinUs() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [job, setJob] = useState("");
  const [otherJob, setOtherJob] = useState("");
  const [message, setMessage] = useState("");
  const [cv, setCv] = useState(null);
  const [cvFileName, setCvFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [join, setJoin] = useState({});
  const [categories, setCategories] = useState([]);
  const { t, i18n } = useTranslation("global");
  const [lang, setLang] = useState(localStorage.getItem("lang") || `"ar"`);
  const isRtl = (i18n.language || "").toLowerCase().startsWith("ar");

  const handleCvUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      setCv(file);
      setCvFileName(file.name);
      toast.success(t("popups.cv"));
    } else if (file && file.type !== "application/pdf") {
      setCv(null);
      setCvFileName("");
      toast.error(t("popups.valid"));
    } else {
      setCv(null);
      setCvFileName("");
      toast.error(t("popups.error"));
    }
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();

    const trimmedName = name.trim();
    const trimmedEmail = email.trim();
    const trimmedMessage = message.trim();
    const trimmedOtherJob = otherJob.trim();
    const finalJob = job === OTHER_JOB_VALUE ? trimmedOtherJob : job;

    if (!trimmedName || !trimmedEmail || !finalJob || !trimmedMessage || !cv) {
      return toast.error(t("popups.fields"));
    }

    if (!EMAIL_REGEX.test(trimmedEmail)) {
      return toast.error(t("popups.emailInvalid"));
    }

    const messageData = new FormData();
    messageData.append("name", trimmedName);
    messageData.append("email", trimmedEmail);
    messageData.append("job", finalJob);
    messageData.append("message", trimmedMessage);
    messageData.append("cv", cv);

    try {
      setLoading(true);
      const response = await toast.promise(
        axios.post("/jobs", messageData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }),
        {
          pending: t("popups.pending"),
        }
      );

      setName("");
      setEmail("");
      setJob("");
      setOtherJob("");
      setMessage("");
      setCv(null);
      setCvFileName("");

      setShowConfirmation(true);

      setTimeout(() => {
        setShowConfirmation(false);
      }, 2500);
    } catch (error) {
      const errorMessage = t("popups.error");
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const getContent = async () => {
      try {
        const response = await axios.get("/content");
        setJoin(response?.data.join);
      } catch (error) {
        toast.error(t("popups.error"));
      }
    };

    const getJobCategories = async () => {
      try {
        const response = await axios.get("/job-categories");
        setCategories(Array.isArray(response?.data) ? response.data : []);
      } catch (error) {
        // Non-fatal: dropdown just renders empty, form still works for other fields.
      }
    };

    getContent();
    getJobCategories();

    const handleStorageChange = () => {
      setLang(localStorage.getItem("lang") || `"ar"`);
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [t]);

  return (
    <>
      <Seo
        title="انضم إلينا"
        description="انضم لفريق الرملاء للصناعات الخشبية — تصفح فرص العمل الحالية وقدّم طلبك."
        path="/join"
      />
      <section className="join-us standardJoin" dir={isRtl ? "rtl" : "ltr"} lang={isRtl ? "ar" : "en"}>
      <StandardJoin>
        <div
          data-aos={lang === `"en"` ? "fade-right" : "fade-left"}
          data-aos-duration="1000"
        >
          {t("join.start")}
        </div>
        <div className="join-heading-container">
          <h1
            data-aos={lang === `"en"` ? "fade-right" : "fade-left"}
            data-aos-duration="1400"
          >
            {lang === `"ar"` ? join?.arMainText : join?.mainText}
          </h1>
          <ul className="join-links">
            <Link to="https://www.linkedin.com/in/alramlaa-wooden-products-513276293/?skipRedirect=true">
              <li
                data-aos={lang === `"en"` ? "fade-left" : "fade-right"}
                data-aos-duration="1000"
              >
                <i className="fab fa-linkedin"></i>
              </li>
            </Link>
            <Link to="https://www.instagram.com/alramlaa.official/" target="_blank">
              <li
                data-aos={lang === `"en"` ? "fade-left" : "fade-right"}
                data-aos-duration="1200"
              >
                <i className="fa-brands fa-instagram"></i>
              </li>
            </Link>

            <Link to="https://www.facebook.com/people/Alramlaa-Wooden-Products/61583094580752/" target="_blank">
              <li
                data-aos={lang === `"en"` ? "fade-left" : "fade-right"}
                data-aos-duration="1400"
              >
                <i className="fa-brands fa-facebook"></i>
              </li>
            </Link>
          </ul>
        </div>
      </StandardJoin>
      <div className="join-us-form">
        <div className="container">
          <div className="join-us-container">
            <div className="join-background">
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/photos/f0753f5583f55f62c53d68710c1e7c6a.webp"
                }
                alt=""
              />
            </div>
            <div className="join-form">
              <h2>
                {" "}
                {lang === `"ar"` ? join?.arSectionTitle : join.sectionTitle}
              </h2>
              <p> {lang === `"ar"` ? join?.arDescription : join.description}</p>
              <form onSubmit={handleSendMessage}>
                <div className="form-group">
                  <label htmlFor="join-name">{t("join.name")}</label>
                  <input
                    id="join-name"
                    name="name"
                    type="text"
                    autoComplete="name"
                    required
                    placeholder="i.e. Davon Lean"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="join-email">{t("join.email")}</label>
                  <input
                    id="join-email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    placeholder="example@gmail.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="join-job">{t("join.job")}</label>
                  {/* Options come from /job-categories (dashboard-managed). join.fit..join.moroccan i18n keys are unused but kept. */}
                  <select
                    id="join-job"
                    required
                    value={job}
                    onChange={(e) => setJob(e.target.value)}
                  >
                    <option value="" disabled>
                      {t("join.job")}
                    </option>
                    {categories.map((cat) => (
                      <option key={cat._id} value={cat.label}>
                        {isRtl ? cat.arLabel : cat.label}
                      </option>
                    ))}
                    <option value={OTHER_JOB_VALUE}>{t("join.other")}</option>
                  </select>
                </div>
                {job === OTHER_JOB_VALUE && (
                  <div className="form-group">
                    <label htmlFor="join-other-job">{t("join.other")}</label>
                    <input
                      id="join-other-job"
                      type="text"
                      required
                      placeholder={t("join.otherPlaceholder")}
                      value={otherJob}
                      onChange={(e) => setOtherJob(e.target.value)}
                    />
                  </div>
                )}
                <div className="form-group">
                  <label htmlFor="join-message">{t("join.message")}</label>
                  <textarea
                    id="join-message"
                    required
                    placeholder={t("join.message")}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  ></textarea>
                </div>
                <div className="upload-btn-wrapper">
                  <button type="button" className="btn">
                    {t("join.upload")}
                  </button>
                  <input
                    type="file"
                    accept="application/pdf"
                    name="myfile"
                    onChange={handleCvUpload}
                  />
                </div>
                {cvFileName && <p className="upload-filename">{cvFileName}</p>}
                <button type="submit" disabled={loading}>
                  {t("join.send")}
                </button>
              </form>
            </div>
          </div>
          {showConfirmation && (
            <div className="confirmation-modal">
              <div className="modal-content sec join-confirmation-modal-inner">
                <img
                  src="/photos/done.svg"
                  alt=""
                  className="join-confirmation-modal-icon"
                />
                <p>{t("popups.thanks")}</p>
                <div className="modal-actions">
                  <button
                    onClick={() => setShowConfirmation(false)}
                    style={{ backgroundColor: "var(--main-color)" }}
                  >
                    {t("popups.okay")}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
    </>
  );
}
export function StandardJoin({ children }) {
  return <div className="container">{children}</div>;
}
export default JoinUs;
